import CommonCardFeesFormHandler from '../../containers/formHandler/cardFees/commonCardFees/CommonCardFeesFormHandler'

const CommonCardFeesPage = () => {
  return (
    <>
      {/* <Heading size="md" mb={"2rem"}>Motif Remplacement Carte</Heading> */}
      <CommonCardFeesFormHandler />
    </>
  )
}

export default CommonCardFeesPage